import { render, staticRenderFns } from "./BlocoAtivosAmbientais.vue?vue&type=template&id=fdc03974&scoped=true&lang=pug"
import script from "./BlocoAtivosAmbientais.vue?vue&type=script&lang=js"
export * from "./BlocoAtivosAmbientais.vue?vue&type=script&lang=js"
import style0 from "./BlocoAtivosAmbientais.vue?vue&type=style&index=0&id=fdc03974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc03974",
  null
  
)

export default component.exports